/**
 * Barra de filtros de la pestana Movimientos de Inventario (INV-01): producto,
 * tipo de movimiento y fechas. Es donde se contesta "por que quedan 95 y no
 * 100": se busca el producto y se lee su historia.
 */
import type { FormEvent } from 'react';

import { conCambio, TIPOS_MOVIMIENTO } from '../../utilidades/filtros-inventario';
import type { FiltrosLibreta as Filtros } from '../../utilidades/filtros-inventario';
import { Icono } from '../comunes/Icono';
import { FiltroFechas } from './FiltroFechas';

export interface FiltrosLibretaProps {
  filtros: Filtros;
  onCambiar(filtros: Filtros): void;
}

export function FiltrosLibreta({ filtros, onCambiar }: FiltrosLibretaProps) {
  const cambiar = (cambio: Partial<Filtros>) => {
    onCambiar(conCambio(filtros, cambio));
  };

  function buscar(evento: FormEvent<HTMLFormElement>): void {
    evento.preventDefault();
    const valor = new FormData(evento.currentTarget).get('termino');
    const texto = typeof valor === 'string' ? valor.trim() : '';
    cambiar({ termino: texto.length > 0 ? texto : undefined });
  }

  return (
    <section className="filtros-tabla" aria-label="Filtros de los movimientos">
      <form className="filtro filtro-buscar" role="search" onSubmit={buscar}>
        <label className="filtro-et" htmlFor="buscar-movimientos">
          Producto
        </label>
        <span className="filtro-buscar-campo">
          {/* `key`: si un chip quita la busqueda, el campo se vacia. */}
          <input
            key={filtros.termino ?? ''}
            id="buscar-movimientos"
            name="termino"
            type="search"
            className={filtros.termino !== undefined ? 'entrada activo' : 'entrada'}
            placeholder="Nombre o codigo"
            defaultValue={filtros.termino ?? ''}
          />
          <button type="submit" className="btn btn-sm btn-primario" aria-label="Buscar">
            <Icono nombre="buscar" />
          </button>
        </span>
      </form>

      <div className="filtro">
        <label className="filtro-et" htmlFor="filtro-tipo-movimiento">
          Motivo
        </label>
        <select
          id="filtro-tipo-movimiento"
          className={filtros.tipo !== undefined ? 'selector activo' : 'selector'}
          value={filtros.tipo ?? ''}
          onChange={(evento) => {
            const elegido = TIPOS_MOVIMIENTO.find((opcion) => opcion.valor === evento.target.value);
            cambiar({ tipo: elegido?.valor });
          }}
        >
          <option value="">Todos</option>
          {TIPOS_MOVIMIENTO.map((opcion) => (
            <option key={opcion.valor} value={opcion.valor}>
              {opcion.texto}
            </option>
          ))}
        </select>
      </div>

      <FiltroFechas
        desde={filtros.desde}
        hasta={filtros.hasta}
        onCambiar={(desde, hasta) => {
          cambiar({ desde, hasta });
        }}
      />
    </section>
  );
}
